export const buildPacksFilterGroups = (venueOwnerships = [], filterOptions = {}) => [
  ...(venueOwnerships.length > 0 ? [{
    id: 'venue',
    label: 'Venue',
    filters: [
      {
        id: 'venue_ownership_id',
        label: 'Venue',
        type: 'checkbox',
        options: venueOwnerships.map((vo) => ({ value: String(vo.id), label: vo.name || vo.venue_name || `Venue ${vo.id}` })),
      },
    ],
  }] : []),
  {
    id: 'pack_details',
    label: 'Pack Details',
    filters: [
      {
        id: 'event_series_id',
        label: 'Series',
        type: 'checkbox',
        options: (filterOptions.series_options || []).map(o => ({ value: o.value, label: o.label })),
      },
      {
        id: 'product',
        label: 'Product',
        type: 'checkbox',
        options: (filterOptions.product_options || []).map(o => ({ value: o.value, label: o.label })),
      },
      {
        id: 'kind',
        label: 'Kind',
        type: 'checkbox',
        options: [
          { value: 'season_pass', label: 'Season Pass' },
          { value: 'flex_pack', label: 'Flex Pack' },
        ],
      },
      {
        id: 'status',
        label: 'Status',
        type: 'checkbox',
        options: [
          { value: 'active', label: 'Active' },
          { value: 'expired', label: 'Expired' },
        ],
      },
      {
        id: 'unredeemed',
        label: 'Redemption',
        type: 'checkbox',
        options: [
          { value: 'true', label: 'Unredeemed only (remaining > 0)' },
        ],
      },
    ],
  },
];
